window.App ||= {}

class App.ModalView extends Backbone.View
  template: JST["backbone/templates/monitoring/modal"]

  events:
    'hidden.bs.modal': 'onClose'

  onClose: ->
    @trigger('modal:closed')

  initialize: (@options = {}) ->
    @tabs = {}
    @render()
    inst = @options.instance
    @$el.find('.modal').addClass('modal-wide') if @options.wide
    @firstTab = @add(inst, true) # active
    @_show()

  render: ->
    @$el.append(@template())
    @$el.first().addClass(@options.className)
    @tabsElement = @$el.find('.tabs')
    @contentsElement = @$el.find('.contents')
    @footerElement = @$el.find('.modal-footer')
    $('body').append(@$el)
    @

  _show: ->
    @modalEl = @$el.find('.modal:first')
    @modalEl.modal()

  add: (inst, activate) ->
    id = @_getRandomId()
    tab = new App.ModalTab({inst:inst, modal:@, modalId:id})
    @tabs[id] = tab
    if(activate)
      @activate(tab);
    @tabsElement.append(tab.tab)
    tab

  activate: (inst) ->
    @_clear();
    @_insert(inst);

  remove: (inst) ->
    delete @tabs[inst.id]
    inst.tab.remove();
    if Object.keys(@tabs).length == 0
      @destroy();
    else
      @tabs[Object.keys(@tabs)[0]]._activate() # activate some other tab

  destroy: () =>
    @modalEl.on('hidden', () =>
      @$el.remove();
    )
    @modalEl.modal('hide')

  disableAll: ->
    @_getAllElements().prop('disabled', true)

  enableAll: ->
    @_getAllElements().prop('disabled', false)

  _getAllElements: ->
    @$el.find('input, textarea, button, select')

  _clear: ()-> # clear the modal, then insert
    @tabsElement.find('li').removeClass('active');
    @contentsElement.contents().detach();
    @footerElement.contents().detach();

  _insert: (inst) ->
    inst.tab.addClass('active')
    @contentsElement.append(inst.content);
    @footerElement.append(inst.buttons);

  _getRandomId: () ->
    _.random(0,100000)


class App.ModalTab extends Backbone.View # A tab in a modal

  initialize: (@options = {}) ->
    @inst = @options.inst
    @modal = @options.modal
    @id = @options.modalId # used by modal
    @tab = @_generateTab();
    @buttons = @_generateButtons();
    @content = @inst.$el
    @

  remove: () =>
    @modal.remove(@)

  removeModal: ->
    @modal.destroy()

  _generateButtons: () ->
    _.collect(@inst.modal.buttons, (e) =>
      @_addButton(e)
    )

  _addButton: (o) ->
    console.log(o.event);
    if ((o.event)=="onDelete")
      $("<button class='btn btn-danger'>#{o.title}</button>").click(@inst[o.event])
    else if (((o.event)=="closeModal") || ((o.event)=="exit"))
      $("<button class='btn margin-left' data-dismiss='modal'>#{o.title}</button>").click(@inst[o.event])
    else
      $("<button class='btn btn-primary pull-right'>#{o.title}</button>").click(@inst[o.event])

  _generateTab: () ->
    $("<li><a>#{@inst.modal.title}</a></li>").click(@_activate)

  _activate : () =>
    @modal.activate(@)
